var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('c-table',{attrs:{"table-data":_vm.data,"fields":_vm.fields,"caption":"Inventory Report"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }